/**
 * @author mi
 * @date 2019/4/23
 * @project xingzhiyuan_2019
 * @desc fn 状态共有四种，ready, loading, loaded, fail, 该函数可防止异步函数重复调用，
 *       如果回调状态已处于 loading, loaded，则之后调用不再执行
 * @example
 * actions = {
 *   getUserBatch: wrapFnExecOnce((setState, { state, commit }, payload, cb) => {
      getUserBatchApi().then((res) => {
        setState('loaded') // 必须调用setState 记录状态
        commit('updateUserBatch', res)
      }).catch(() => {
        setState('fail')
      })
    })
  }
 */
let fnRecord = {}
let fnId = 0 // 函数id
console.log(fnId, fnRecord)
export function wrapFnExecOnce (fn) {
  fnId++
  return (function (rec, id) {
    rec[id] = 'ready'
    return function () {
      let args = arguments
      
      console.log(arguments, 'arguments')
      return new Promise((resolve, reject) => {
        if (rec[id] === 'loaded') {
          resolve('loaded')
        }
  
        if (rec[id] === 'loaded' || rec[id] === 'loading') return rec[id]
        rec[id] = 'loading'
        fn((state) => {
          rec[id] = state
          if (state === 'loaded') {
            resolve('loaded')
          }
        }, ...args)
      })
    }
  })(fnRecord, fnId)
}
